export const state = {
	threads: []
}



// WEBPACK FOOTER //
// ./src/common/store/Chat/state.js